// NOTE: hooks
import { Outlet, Navigate, useLocation } from 'react-router-dom'
import { useAuthContext } from '../../hooks/useAuthContext'
import useCheckoutResult from '../../hooks/useCheckoutResult'
// NOTE: components
import NavBar from './NavBar'
import StaffInvitation from '../staffInvitation/StaffInvitation'
import { PageErrorBoundaryWrapper } from '../errorBoundary/ErrorBoundary'
// NOTE: images
import {
	PiHouseFill as HomeIcon,
	PiHouse as HomeOutlineIcon,
} from 'react-icons/pi'
import { HiCalendar as CalendarIcon} from "react-icons/hi";
import { HiOutlineCalendar as CalendarOutlineIcon } from "react-icons/hi";
import {
	RiHealthBookFill as HeartIcon,
	RiHealthBookLine as HeartOutlineIcon
} from "react-icons/ri"
import {
	HiMiniHeart as CareIcon,
	HiOutlineHeart as CareOutlineIcon
} from 'react-icons/hi2'

/**
 * Display the page with the appropriate navbar and perform actions common to all the pages in the different dashboards
 * 	Staff dashboard: check if they were invited to join a company
 * 	Manager dashboard: check if the company context needs to be updated
 *
 * @param {String} links - links to display on the navbar
 * @param {String} home - link to the home page of the dashboard
 * @param {String} icon - icon to display at the top of the desktop navbar
 */

const Layout = () => {
	const { user } = useAuthContext()
	const location = useLocation()

	useCheckoutResult()

	// NOTE: redirect login page
	if (!user) {
		const prevSearch = window.location.search
		const search = `${prevSearch ? `${prevSearch}&` : '?'}redirect=${window.location.pathname}`

		return (
			<Navigate
				to={{
					pathname: '/auth',
					search: search
				}}
			/>
		)
	}

	const navLinks = [
		{
			to: '/',
			text: 'Home',
			activeIcon: <HomeIcon className="mx-auto h-auto w-[34px] lg:mx-0 lg:w-[30px]" />,
			inactiveIcon: <HomeOutlineIcon className="mx-auto h-auto w-[34px] lg:mx-0 lg:w-[30px]" />
		},
		{
			to: '/health',
			text: 'Health',
			activeIcon: <HeartIcon className="mx-auto h-auto w-[34px] lg:mx-0 lg:w-[30px]" />,
			inactiveIcon: <HeartOutlineIcon className="mx-auto h-auto w-[34px] lg:mx-0 lg:w-[30px]" />
		},
		{
			to: '/calendar',
			text: 'Calendar',
			activeIcon: <CalendarIcon className="mx-auto h-auto w-[34px] lg:mx-0 lg:w-[30px]" />,
			inactiveIcon: <CalendarOutlineIcon className="mx-auto h-auto w-[34px] lg:mx-0 lg:w-[30px]" />
		},
		{
			to: '/clinic',
			text: 'Clinic',
			activeIcon: <CareIcon className="mx-auto h-auto w-[34px] lg:mx-0 lg:w-[30px]" />,
			inactiveIcon: <CareOutlineIcon className="mx-auto h-auto w-[34px] lg:mx-0 lg:w-[30px]" />
		}
	]

	return (
		<>
			<StaffInvitation />
			<div className="flex min-h-screen min-h-svh">
				<NavBar links={navLinks} />

				<PageErrorBoundaryWrapper key={location.pathname} className="w-full">
					<Outlet />
				</PageErrorBoundaryWrapper>
			</div>
		</>
	)
}

export default Layout
